export default ({page, pageSize, totalEntityCount, orderBy = null, orderByAscending = null}) => {
	return {
		page,
		pageSize,
		totalEntityCount,
		column: orderBy,
		direction: orderByAscending ? 'asc' : 'desc'
	};
};
